'use client';

import React, { useState, useEffect } from 'react';


interface Resource {
  id: number;
  title: string;
  description: string;
  type: string;
  category: string;
  downloadSize: string;
  icon: string;
}

interface ResourcesLibraryProps {
  className?: string;
}

const ResourcesLibrary = ({ className = '' }: ResourcesLibraryProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('All');

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const resources: Resource[] = [
  {
    id: 1,
    title: 'EU-GMP Compliance Checklist',
    description: 'Comprehensive checklist covering all EU-GMP requirements for pharmaceutical manufacturing facilities.',
    type: 'PDF',
    category: 'Compliance',
    downloadSize: '2.4 MB',
    icon: 'DocumentCheckIcon'
  },
  {
    id: 2,
    title: 'CTD Module 3 Template',
    description: 'Pre-formatted template for Common Technical Document Module 3 (Quality) submissions.',
    type: 'DOCX',
    category: 'Templates',
    downloadSize: '1.8 MB',
    icon: 'DocumentTextIcon'
  },
  {
    id: 3,
    title: 'ANVISA Registration Guide 2026',
    description: 'Step-by-step guide for pharmaceutical product registration with Brazilian health authority ANVISA.',
    type: 'PDF',
    category: 'Guides',
    downloadSize: '3.2 MB',
    icon: 'BookOpenIcon'
  },
  {
    id: 4,
    title: 'Regulatory Intelligence Report Q1 2026',
    description: 'Quarterly analysis of global regulatory changes, trends, and their impact on pharmaceutical industry.',
    type: 'PDF',
    category: 'Intelligence',
    downloadSize: '4.1 MB',
    icon: 'ChartBarIcon'
  },
  {
    id: 5,
    title: 'Audit Preparation SOP Template',
    description: 'Standard Operating Procedure template for preparing manufacturing facilities for regulatory audits.',
    type: 'DOCX',
    category: 'Templates',
    downloadSize: '1.5 MB',
    icon: 'ClipboardDocumentListIcon'
  },
  {
    id: 6,
    title: 'WHO-GMP Requirements Overview',
    description: 'Detailed overview of World Health Organization Good Manufacturing Practice requirements and implementation.',
    type: 'PDF',
    category: 'Compliance',
    downloadSize: '2.8 MB',
    icon: 'ShieldCheckIcon'
  },
  {
    id: 7,
    title: 'Market Entry Strategy Framework',
    description: 'Strategic framework for planning and executing pharmaceutical market entry across multiple jurisdictions.',
    type: 'PDF',
    category: 'Guides',
    downloadSize: '3.5 MB',
    icon: 'MapIcon'
  },
  {
    id: 8,
    title: 'Variation Management Toolkit',
    description: 'Complete toolkit for managing post-approval variations including templates and submission guidelines.',
    type: 'ZIP',
    category: 'Templates',
    downloadSize: '5.2 MB',
    icon: 'FolderIcon'
  }];


  const categories = ['All', 'Compliance', 'Templates', 'Guides', 'Intelligence'];

  const filteredResources = selectedCategory === 'All' ?
  resources :
  resources.filter((resource) => resource.category === selectedCategory);

  const handleDownload = (resourceTitle: string) => {
    if (!isHydrated) return;
    alert(`Downloading: ${resourceTitle}\n\nThis is a demo. In production, this would initiate the file download.`);
  };

  if (!isHydrated) {
    return (
      <section className={`py-16 bg-muted/30 ${className}`}>
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-textPrimary mb-4">
              Regulatory Resources Library
            </h2>
            <p className="text-lg text-textSecondary">Loading resources...</p>
          </div>
        </div>
      </section>);

  }

  return;































































































};

export default ResourcesLibrary;